import React, { useEffect } from 'react';
import './FullscreenPopup.scss';
// import Cube360 from './cube';
// import { Canvas } from '@react-three/fiber';
// import Controls from 'containers/world/controls';
// import { PerspectiveCamera } from '@react-three/drei';
// import { getCameraPositionFromLookAtCoordinates } from 'utils/positionHelper';
import { useDispatch } from 'react-redux';
import BackButtonPill from 'components/buttons/BackButtonPill';
import GuideBoard from 'components/GuideBoard/GuideBoard';
import { WorldFC } from 'components/World';

import { createPortal } from 'react-dom';
import { setIsPopupOpen } from 'store/actions';

const FullscreenPopup = ({
  isOpen,
  onClose,
  scenes = [],
  sceneId,
  isPage = false,
}) => {
  const dispatch = useDispatch();

  useEffect(() => {
    if (!isOpen || isPage) return;

    dispatch(setIsPopupOpen(true));

    return () => {
      dispatch(setIsPopupOpen(false));
    };
  }, [dispatch, isOpen, isPage]);

  if (!isOpen) return null;

  if (!sceneId) {
    console.error('Scene not found for FullscreenPopup');
    return null;
  }

  // Minimal cubeA stepHandlers object sufficient for Cube360
  // const cubeA = {
  //   sceneData,
  //   stepPosition: [0, 0, 0],
  //   sceneRotation: [0, 0, 0],
  //   positionNext: [0, 0, 0],
  //   active: true,
  //   prevRotation: 0,
  //   rotations: [{ rad: 0, deg: 0 }],
  //   onClickStep: () => {},
  // };

  // const cameraPosition = getCameraPositionFromLookAtCoordinates(
  //   sceneData.defaultOrientation[0],
  //   sceneData.defaultOrientation[1],
  //   sceneData.defaultOrientation[2]
  // );

  return createPortal(
    <div className="fullscreen-popup-overlay">
      <div className="fullscreen-popup-content">
        <BackButtonPill onClick={onClose} label="Back" />
        <div className="fullscreen-popup-body">
          {/* <Canvas>
            <PerspectiveCamera
              makeDefault
              position={[cameraPosition.x, cameraPosition.y, cameraPosition.z]}
            />
            <Cube360 scenes={scenes} pano={sceneData} stepHandlers={cubeA} />

            <Controls
              // autoRotate={viewMode === 'preview' ? true : shouldRotate}
              // autoRotateSpeed={
              //   viewMode === 'preview' ? null : tour.autoRotateSpeed
              // }
              enableDamping={true}
              enable={true}
            />
          </Canvas> */}

          <WorldFC />

          <GuideBoard />
        </div>
      </div>
    </div>,
    document.body
  );
};

export default FullscreenPopup;
